import { Constants as MoltenConstants } from '@leverege/molten';
import { Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import FotaApi from "../api/FotaApi.js";
import { Types } from "../constants/index.js";
import ReleaseFirmware from "../actions/imagineDevice/ReleaseFirmware.js";
import ResumeFirmwareRelease from "../actions/imagineDevice/ResumeFirmwareRelease.js";
import StopFirmwareRelease from "../actions/imagineDevice/StopFirmwareRelease.js";
import PauseFirmwareRelease from "../actions/imagineDevice/PauseFirmwareRelease.js";
import UpdateDeviceGroup from "../actions/imagineDevice/UpdateDeviceGroup.js";
async function createReleaseByImagineGroupsActions(molten, blueprints) {
  const systemId = molten.getConfig('api/systemId');
  const api = new FotaApi({
    relationship: {
      options: {
        systemId
      }
    }
  });
  let deviceTypes;
  try {
    deviceTypes = await GlobalState.dispatch(api.getAll('deviceType'));
  } catch (err) {
    console.log('failed to create imagine firmware release actions: get all deviceTypes', err);
    return;
  }
  const hasImagineType = deviceTypes?.items?.filter(dt => Attributes.get('options.imagine.groupBlueprintId', Types.deviceType, dt) != null);
  hasImagineType.forEach(deviceType => {
    const bpId = Attributes.get('options.imagine.groupBlueprintId', Types.deviceType, deviceType);
    const blueprint = blueprints.find(bp => bp.id === bpId);
    if (blueprint) {
      molten.addPlugin('Action', ReleaseFirmware({
        deviceType,
        blueprint
      }));
      molten.addPlugin('Action', PauseFirmwareRelease({
        deviceType,
        blueprint
      }));
      molten.addPlugin('Action', ResumeFirmwareRelease({
        deviceType,
        blueprint
      }));
      molten.addPlugin('Action', StopFirmwareRelease({
        deviceType,
        blueprint
      }));
      molten.addPlugin('Action', UpdateDeviceGroup({
        deviceType,
        blueprint
      }));
    }
  });
}
const ImagineGroupReleaseAnalyzer = {
  type: MoltenConstants.BLUEPRINTS_PROCESSOR,
  id: `${Types.apiName}.ReleaseByImagineGroupsAnalyzer`,
  processBlueprints: createReleaseByImagineGroupsActions
};
export default ImagineGroupReleaseAnalyzer;